/**
 * Reset iterations and delete active triggers when timeline finishes in "enter" or "leave" mode
 * @param {TimelineMapProps} timeline
 * @param {Boolean} enter
 */
const resetOffsetIterations = (timeline, enter) => {
  timeline.set("is-alternating", false);
  timeline.set("is-iterating", false);

  /** Finished in "enter" mode */
  if (enter) {
    timeline.set("leave-time", null);
  } else {
    /** Reset on timeline finish in "leave" mode */
    timeline.set("current-iteration", 0);
    timeline.set("enter-time", null);
    timeline.set("pause-enter-time", null);
  }
}

export default resetOffsetIterations;